// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimTransferAccountResponse
 */
export interface IClaimTransferAccountResponse {
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferAccountResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimTransferAccountResponse
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferAccountResponse
     */
    amount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferAccountResponse
     */
    commuter_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferAccountResponse
     */
    election_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferAccountResponse
     */
    category_spend_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferAccountResponse
     */
    person_spend_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferAccountResponse
     */
    rollover_limit?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimTransferAccountResponse
     */
    is_locked: boolean;
    /**
     * 
     * @type {string}
     * @memberof IClaimTransferAccountResponse
     */
    spend_period_type?: IClaimTransferAccountResponseSpendPeriodTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IClaimTransferAccountResponseSpendPeriodTypeEnum {
    UNLIMITED = 'UNLIMITED',
    MONTHLY = 'MONTHLY',
    PLAN_YEAR = 'PLAN_YEAR'
}


/**
 * Check if a given object implements the IClaimTransferAccountResponse interface.
 */
export function instanceOfIClaimTransferAccountResponse(value: object): value is IClaimTransferAccountResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('is_locked' in value) || value['is_locked'] === undefined) return false;
    return true;
}

export function IClaimTransferAccountResponseFromJSON(json: any): IClaimTransferAccountResponse {
    return IClaimTransferAccountResponseFromJSONTyped(json, false);
}

export function IClaimTransferAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimTransferAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'commuter_limit': json['commuter_limit'] == null ? undefined : json['commuter_limit'],
        'election_limit': json['election_limit'] == null ? undefined : json['election_limit'],
        'category_spend_limit': json['category_spend_limit'] == null ? undefined : json['category_spend_limit'],
        'person_spend_limit': json['person_spend_limit'] == null ? undefined : json['person_spend_limit'],
        'rollover_limit': json['rollover_limit'] == null ? undefined : json['rollover_limit'],
        'is_locked': json['is_locked'],
        'spend_period_type': json['spend_period_type'] == null ? undefined : json['spend_period_type'],
    };
}

export function IClaimTransferAccountResponseToJSON(json: any): IClaimTransferAccountResponse {
    return IClaimTransferAccountResponseToJSONTyped(json, false);
}

export function IClaimTransferAccountResponseToJSONTyped(value?: IClaimTransferAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'amount': value['amount'],
        'commuter_limit': value['commuter_limit'],
        'election_limit': value['election_limit'],
        'category_spend_limit': value['category_spend_limit'],
        'person_spend_limit': value['person_spend_limit'],
        'rollover_limit': value['rollover_limit'],
        'is_locked': value['is_locked'],
        'spend_period_type': value['spend_period_type'],
    };
}

